import { render, staticRenderFns } from "./confirmation-info.vue?vue&type=template&id=4fa632d8&scoped=true&"
import script from "./confirmation-info.vue?vue&type=script&lang=js&"
export * from "./confirmation-info.vue?vue&type=script&lang=js&"
import style0 from "./confirmation-info.vue?vue&type=style&index=0&id=4fa632d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa632d8",
  null
  
)

export default component.exports